import { Injectable } from '@angular/core';
import { appLanguages } from '@gah-core/utils/app-languages';
import { TranslateService } from '@ngx-translate/core';
import { defaultAppLanguage } from '@gah-core/constants/common-constants';

@Injectable({
  providedIn: 'root',
})
export class AppUtilService {
  constructor(private translate: TranslateService) {}

  getAllLanguageCodes() {
    const languageCodes = [] as string[];
    appLanguages.map((language) => languageCodes.push(language.localeCode));
    return languageCodes;
  }

  getRegularExpForLangCodes() {
    const regex = new RegExp(this.getAllLanguageCodes().join('|'));
    return regex;
  }

  getCurrentAppLanguage() {
    return this.translate.currentLang
      ? this.translate.currentLang
      : this.translate.getBrowserLang().match(this.getRegularExpForLangCodes())
      ? this.translate.getBrowserLang()
      : defaultAppLanguage;
  }
}
